import { useTranslation } from 'react-i18next';

export default function WhatIsSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-100" id="guide">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6 text-center">
          {t('whatIsTitle')}
        </h2>
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="lg:w-1/2">
            <div className="w-full h-64 md:h-80 rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20minimalist%20desk%20with%20laptop%20showing%20product%20comparison%20spreadsheet%20alongside%20fashion%20sneakers%20and%20accessories%20samples%2C%20warm%20cream%20workspace%2C%20soft%20natural%20light%20from%20window%2C%20editorial%20productivity%20photography%2C%20clean%20sophisticated%20composition%2C%20warm%20neutral%20tones%2C%20high%20detail&width=800&height=600&seq=cssbuy-whatis-v4&orientation=landscape"
                alt="O que e o CSSBuy Spreadsheet - Planilha de produtos organizada"
                title="CSSBuy Spreadsheet - Colecao organizada de produtos"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
            </div>
          </div>
          <div className="lg:w-1/2 space-y-4">
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
              {t('whatIsDesc1')}
            </p>
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
              {t('whatIsDesc2')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}